import { ref } from 'vue';
import { defineStore } from 'pinia';

const defaultPos = { top: 0, left: 0 };

export const useContextMenuStore = defineStore('contextMenu', () => {
  const shown = ref(false);
  const position = ref(defaultPos);
  const menuItems = ref([]);

  function openContextMenu(event, items = []) {
    if (!items || !items.length) {
      return console.error(
        'Ошибка отображения контекстного меню. ' +
        'Отсутствуют элементы для отображения'
      );
    }

    shown.value = true;
    menuItems.value = items;
    position.value = {
      top: event.clientY,
      left: event.clientX
    };
  }

  function closeContextMenu() {
    shown.value = false;
    position.value = defaultPos;
    menuItems.value = [];
  }

  return {
    shown,
    position,
    menuItems,

    openContextMenu,
    closeContextMenu,
  };
});
